import { ShieldCheck } from "lucide-react";

export function EtiquetteNote({ wali, className = "" }) {
  return (
    <div className={`rounded-xl border border-amber-200 bg-amber-50 p-4 text-left ${className}`} data-testid="etiquette-note">
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900"><ShieldCheck className="h-4 w-4" /> A gentle reminder</p>
      <p className="mt-1 text-sm leading-relaxed text-amber-800/90">Reach out with sincerity and respect. In keeping with Islamic etiquette, we encourage involving a wali (guardian) early in the conversation.</p>
      {wali?.name ? (
        <p className="mt-2 rounded-lg bg-white/70 p-2 text-sm text-amber-900" data-testid="wali-contact"><b>Wali:</b> {wali.name}{wali.relation ? ` (${wali.relation})` : ""}{wali.contact ? ` — ${wali.contact}` : ""}</p>
      ) : (
        <p className="mt-2 text-xs text-amber-700">Tip: politely ask about their wali when you connect.</p>
      )}
    </div>
  );
}
